import { Color } from 'vscode/vscode/vs/base/common/color';
import './media/stickyScroll.css.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { registerColor } from 'vscode/vscode/vs/platform/theme/common/colorUtils';
import 'vscode/vscode/vs/platform/theme/common/colors/baseColors';
import 'vscode/vscode/vs/platform/theme/common/colors/chartsColors';
import 'vscode/vscode/vs/platform/theme/common/colors/editorColors';
import 'vscode/vscode/vs/platform/theme/common/colors/inputColors';
import 'vscode/vscode/vs/platform/theme/common/colors/listColors';
import 'vscode/vscode/vs/platform/theme/common/colors/menuColors';
import 'vscode/vscode/vs/platform/theme/common/colors/minimapColors';
import 'vscode/vscode/vs/platform/theme/common/colors/miscColors';
import 'vscode/vscode/vs/platform/theme/common/colors/quickpickColors';
import 'vscode/vscode/vs/platform/theme/common/colors/searchColors';

const _moduleId = "vs/workbench/contrib/terminalContrib/stickyScroll/browser/terminalStickyScrollColorRegistry";
const terminalStickyScrollBackground = registerColor('terminalStickyScroll.background', {
    light: null,
    dark: null,
    hcDark: null,
    hcLight: null
}, ( localizeWithPath(
    _moduleId,
    0,
    'The background color of the sticky scroll overlay in the terminal.'
)));
const terminalStickyScrollHoverBackground = registerColor('terminalStickyScrollHover.background', {
    dark: '#2A2D2E',
    light: '#F0F0F0',
    hcDark: null,
    hcLight: ( (( (Color.fromHex('#0F4A85'))).transparent(0.1)))
}, ( localizeWithPath(
    _moduleId,
    1,
    'The background color of the sticky scroll overlay in the terminal when hovered.'
)));

export { terminalStickyScrollBackground, terminalStickyScrollHoverBackground };
